import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import MaterialTable from "../../components/Table/MaterialTable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const BookingActivityPools = () => {
  const [activityPools, setActivityPools] = useState([]);

  const columns = [
    { field: "hotel_name", title: "Hotel", type: "text" },
    { field: "booking_date", title: "Booking Date", type: "date" },
    { field: "activity_id", title: "Activity ID", type: "number" },
    { field: "unit_type", title: "Unit Type", type: "text" },
    { field: "start_time", title: "Start Time", type: "datetime" },
    { field: "end_time", title: "End Time", type: "datetime" },
    { field: "last_updated", title: "Last Updated", type: "datetime" },
  ];

  useEffect(() => {
    const fetchActivityPools = async () => {
      try {
        const response = await fetch(
          "https://api.esthell.com/BookingActivityPools",
        );
        const data = await response.json();
        if (data.success) {
          setActivityPools(data.data);
        }
      } catch (error) {
        console.error("Error fetching activity pools:", error);
      }
    };

    fetchActivityPools();
  }, []);
  const handleExportToExcel = () => {
    const formattedData = activityPools.map((item) => ({
      Hotel: item.hotel_name,
      "Booking Date": item.booking_date,
      "Activity ID": item.activity_id,
      "Unit Type": item.unit_type,
      "Start Time": item.start_time,
      "End Time": item.end_time,
      "Last Updated": item.last_updated,
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ActivityPools");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "BookingActivityPools.xlsx");
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography
        variant="h4"
        sx={{ mb: 3, color: "#1a237e", fontWeight: "bold" }}
      >
        Booking Activity Pools
      </Typography>

      <Button
        variant="contained"
        color="primary"
        sx={{ mb: 2 }}
        onClick={handleExportToExcel}
      >
        Export to Excel
      </Button>
      <MaterialTable
        columns={columns}
        data={activityPools}
        printTitle="Booking Activity Pools"
        enableRowActions={false}
        editable={{ isEditable: false, isDeletable: false }}
      />
    </Box>
  );
};

export default BookingActivityPools; // Make sure this line exists
